export const data = [
    {
        id: 1,
        name: 'Hamburger',
        category: 'Burger',
        image: 'https://th.bing.com/th/id/OIP.WVSMGVHxyqtfaZM9sfPywQHaE5?pid=ImgDet&rs=1',
        price: '$250',
    },

    {
        id: 2,
        name: 'Mushroom burger',
        category: 'Burger',
        image: 'https://th.bing.com/th/id/OIP.Rcvh3oQQbKUsTrOFV2M0egHaE7?pid=ImgDet&rs=1',
        price: '$300',
    },

    {
        id: 3,
        name: 'Hotdog',
        category: 'Hot dog',
        image: 'https://th.bing.com/th/id/OIP.m2ljXWCdOtHDt-Wz-ZOM8wHaE8?pid=ImgDet&rs=1',
        price: '$100',
    },

    {
        id: 4,
        name: 'Double Cheeseburger',
        category: 'Burger',
        image: 'https://th.bing.com/th/id/OIP.crSq4E_QNc5jRsfRik3iVgHaGA?pid=ImgDet&rs=1',
        price: '$150',
    },

    {
        id: 5,
        name: 'Meat Lovers',
        category: 'Pizza',
        image: 'https://th.bing.com/th/id/OIP.-ei61GJRJmYE-mq_CVTV2QHaHa?pid=ImgDet&rs=1',
        price: '$400',
    },

    {
        id: 6,
        name: 'Cheese Pizza',
        category: 'Pizza',
        image: 'https://th.bing.com/th/id/OIP.8c6tJ_mqAUOXA3XI3xH8JwHaE6?pid=ImgDet&rs=1',
        price: '$500',
    },

    {
        id: 7,
        name: 'Fried Rice',
        category: 'Cereal',
        image: 'https://th.bing.com/th/id/OIP.AZO5ZmWS9s0Bsc4NMMjoKwHaFj?pid=ImgDet&rs=1',
        price: '$550',
    },

    {
        id: 8,
        name: 'Jollof Rice',
        category: 'Cereal',
        image: 'https://th.bing.com/th/id/OIP.5-1wEg0RaPeq25Ouht149AHaE7?pid=ImgDet&rs=1',
        price: '$450',
    },

    {
        id: 9,
        name: 'Spaghetti',
        category: 'Cereal',
        image: 'https://th.bing.com/th/id/R.30d4a31b2cc4d9b9ad0f5757fe92a447?rik=nunkc8W41YgiCA&riu=http%3a%2f%2fwww.mnftiu.cc%2fwp-content%2fuploads%2f2013%2f12%2fspaghetti-with-tomato-sauce.jpg&ehk=M%2fI2tiveGEI7u6Fm89ArTmYVMxZiew2h2XM%2bNHGsmPo%3d&risl=&pid=ImgRaw&r=0',
        price: '$350',
    },

    {
        id: 10,
        name: 'Egousi Soup',
        category: 'Melon',
        image: 'https://th.bing.com/th/id/R.ff704fc430007ead21f062ccc76ca8f6?rik=pd%2f1QLBYMCCWkw&pid=ImgRaw&r=0',
        price: '$250',
    },

    {
        id: 11,
        name: 'Chicken Breast',
        category: 'Meat',
        image: 'https://bigoven-res.cloudinary.com/image/upload/t_recipe-1280/honey-garlic-chicken-breast-78372a.jpg',
        price: '$700',
    },

    {
        id: 12,
        name: 'Grilled Pork',
        category: 'Meat',
        image: 'https://th.bing.com/th/id/OIP.HJ5gcypPNa2r96_ekrjEKQHaEK?pid=ImgDet&rs=1',
        price: '$650',
    },

    {
        id: 13,
        name: 'Roasted Goat',
        category: 'Meat',
        image: 'https://th.bing.com/th/id/OIP.l83opO6t_0rHDkDfuy-uxQHaD3?pid=ImgDet&rs=1',
        price: '$900',
    },

    {
        id: 14,
        name: 'Calamari',
        category: 'Meat',
        image: 'https://th.bing.com/th/id/OIP.RhNLC3GVV64B3e_l0Rr2dQHaEK?pid=ImgDet&rs=1',
        price: '$750',
    },

    {
        id: 15,
        name: 'Baked Chicken',
        category: 'Meat',
        image: 'https://th.bing.com/th/id/R.257166cf93fa896a5eb9462d66299536?rik=8kOZCLA3A5aEuQ&pid=ImgRaw&r=0',
        price: '$300',
    },

    {
        id: 16,
        name: 'Wings',
        category: 'Meat',
        image: 'https://whereismyspoon.co/wp-content/uploads/2020/10/turkey-wings-recipe.jpg',
        price: '$1500',
    },
];

export const categories = [
    {
        id: 1,
        name: 'Shipped free',
        image: 'https://th.bing.com/th/id/R.b9f61dda586230dc52fddbcea79da069?rik=n52W4Mz4O9FqrQ&riu=http%3a%2f%2fwww.addalittledazzle.com%2fwp-content%2fuploads%2f2014%2f10%2fDepositphotos_52829059_s-e1412780919532.jpg&ehk=8lrL6OLQ6%2b1hLlZTMzdKqwFQZAeXzJbtOQiebfJrX5s%3d&risl=&pid=ImgRaw&r=0',
    },

    {
        id: 2,
        name: 'Best Overall',
        image: 'https://th.bing.com/th/id/OIP.an83six7icxu5CRo5KaN4wHaL2?pid=ImgDet&rs=1',
    },

    {
        id: 3,
        name: 'Restaurant Rewards',
        image: 'https://th.bing.com/th/id/R.ae531dd31105a9b5ceb33dd562b38d34?rik=rzt61wOd5BrV5Q&pid=ImgRaw&r=0',
    },

    {
        id: 4,
        name: 'Latest Deals',
        image: 'https://th.bing.com/th/id/OIP.YhkW2mWNLQnOWRlp0bzugAHaE7?pid=ImgDet&rs=1',
    },

    {
        id: 5,
        name: 'Miami',
        image: 'https://th.bing.com/th/id/OIP.FiKIBqzGGt9Vr1GZJbXczAHaDt?pid=ImgDet&rs=1',
    },

    {
        id: 6,
        name: 'Wings',
        image: 'https://th.bing.com/th/id/OIP.-FvOlsgPFqUtOqO49xwHoAHaE8?pid=ImgDet&rs=1',
    },

    {
        id: 7,
        name: 'Pizza',
        image: 'https://th.bing.com/th/id/R.7270616baff07e0a3607fb988502806e?rik=GhH3BIklCbx1NQ&pid=ImgRaw&r=0',
    },

    {
        id: 8,
        name: 'Fast Food',
        image: 'https://th.bing.com/th/id/R.b189b43731d0e9268536d1ea95221ff8?rik=tBroRqfQHeJe4g&riu=http%3a%2f%2fstatic.dnaindia.com%2fsites%2fdefault%2ffiles%2fstyles%2fhalf%2fpublic%2f2016%2f03%2f06%2f434220-fast-food.jpg%3fitok%3dIiHHN3Fv&ehk=H74VH8hR%2fTxnH9%2f8sJ0XqwFDFa5H2et9lsa7UIZnpfU%3d&risl=&pid=ImgRaw&r=0',
    },
];